import { api } from './client';
import type { SendAidRequest, SendAidResponse } from '../types/aid';

/**
 * Send aid (resources) to another province in the same kingdom.
 */
export async function sendAid(
  worldId: string,
  provinceId: string,
  request: SendAidRequest
): Promise<SendAidResponse> {
  const response = await api.post<SendAidResponse>(
    `/api/worlds/${worldId}/provinces/${provinceId}/aid`,
    request
  );
  if (response.error || !response.data) {
    throw new Error(response.error || 'Failed to send aid');
  }
  return response.data;
}
